import { App, effectScope } from 'vue'

import {
	DefaultsInstance,
	DefaultsSymbol,
	ThemeOptions,
	ThemeSymbol,
	createDefaults,
	initiateTheme
} from './composables'
import {
	LayoutOptions,
	LayoutSymbol,
	createLayout
} from './composables/use-layout'

export interface UiKitOptions {
	defaults?: DefaultsInstance
	theme?: ThemeOptions
	layout?: LayoutOptions
}

export function createUiKit(options: UiKitOptions = {}) {
	const scope = effectScope()

	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return scope.run(() => {
		function install(app: App) {
			const defaults = createDefaults(options.defaults)
			const theme = initiateTheme(options.theme)
			const layout = createLayout(options.layout)

			app.provide(DefaultsSymbol, defaults)
			app.provide(ThemeSymbol, theme)
			app.provide(LayoutSymbol, layout)
		}

		function unmount() {
			scope.stop()
		}

		return {
			install,
			unmount
		}
	})!
}
